import {Button} from '../../../components/button';
import {useCurrentTeam, useCurrentUser} from '../../../hooks';
import {getUserFullName} from '../../../utils';
import Styles from './Account.module.scss';

export const AccountDeletion = () => {
  const currentUser = useCurrentUser();
  const {id, email} = currentUser;
  const {id: teamId} = useCurrentTeam();
  const fullName = getUserFullName(currentUser);

  const mailtoHref = `mailto:support@theswarm.com?subject=Request for Account Removal&body=Dear The Swarm Support Team,

I am writing to request the complete removal of my account from your system.
Account Information:

Name: ${fullName}
Email: ${email}
Account ID: ${id}
Team ID: ${teamId}

Please delete all of my personal data associated with this account in accordance with your privacy policy and applicable data protection regulations.

I understand that this action cannot be undone and I will lose access to all services, content, and information tied to my account.
Thank you for your assistance.

Sincerely,
${fullName}
`;

  return (
    <div className={Styles.settingsActionBoxWrapper}>
      <p className={Styles.settingsActionBoxInfo}>
        All data from your Swarm account will be permanently deleted.
        <br />
        Click the button to send a request.
      </p>
      <Button variant="red" tracking={{label: 'request account removal'}} href={encodeURI(mailtoHref)}>
        Request account removal
      </Button>
    </div>
  );
};
